<template>
  <div style="margin: 10px 40px 0px">
    <el-form :model="sipObj" :rules="sipRules" ref="sipObj" label-width="130px" class="demo-ruleForm">
      <el-row>
        <el-col :span="12">
          <el-form-item label="SIP登录名" prop="username">
            <el-input style="width: 90%;"  v-model="sipObj.username"  placeholder="SIP登录名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="SIP密码" prop="password">
            <el-input style="width: 90%;"  v-model="sipObj.password"  placeholder="SIP密码"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="电话登录名" prop="sip_username">
            <el-input style="width: 90%;"  v-model="sipObj.sip_username"  placeholder="电话登录名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="电话密码" prop="sip_password">
            <el-input style="width: 90%;"  v-model="sipObj.sip_password"  placeholder="电话密码"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="电话所在组" prop="sip_orgid">
            <el-input style="width: 90%;"  v-model="sipObj.sip_orgid"  placeholder="当前是8"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="电话所在list" prop="sip_id_list">
            <el-input style="width: 90%;"  v-model="sipObj.sip_id_list"  placeholder="当前是2"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="电话类型" prop="sip_type">
        <el-radio-group v-model="sipObj.sip_type">
          <el-radio :label="1">SIP</el-radio>
          <el-radio :label="2">WebRTC</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="SIP服务器地址" prop="sip_svrip">
        <el-input style="width: 96%;"  v-model="sipObj.sip_svrip"  placeholder="SIP服务器地址"></el-input>
      </el-form-item>
      <el-form-item label="所属组织" prop="orgid">
        <el-cascader v-fixZoom
          style="width: 96%"
          :options="orgOptions"
          v-model="sipObj.orgid"
          :filterable="true"
          placeholder="请选择所属组织"
          :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}"
          ref="orgOptions">
        </el-cascader>
      </el-form-item>
    </el-form>
    <div>
      <el-row style="margin: 0 100px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeAddEdit()">
            <span>取消</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="addEditSip('sipObj')">
            <span>确定</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="height: 30px"></div>
  </div>
</template>

<script>
import {addsip, updatesip} from '../../../api/sipPhone'

export default {
  name: 'sipAddEdit',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    sipAddEditRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      orgOptions: [],
      sip_types: [
        {name: 'SIP', type: 1},
        {name: 'WebRTC', type: 2}
      ],
      sipObj: {
        id: 0,
        orgid: '',
        username: '',
        password: '',
        sip_username: '',
        sip_password: '',
        sip_orgid: '',
        sip_id_list: '',
        sip_svrip: '',
        sip_type: ''
      },
      sipRules: {
        username: [
          { required: true, message: '请输入SIP登录名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入SIP密码', trigger: 'blur' }
        ],
        sip_username: [
          { required: true, message: '请输入电话登录名', trigger: 'blur' }
        ],
        sip_password: [
          { required: true, message: '请输入电话密码', trigger: 'blur' }
        ],
        sip_orgid: [
          { required: true, message: '请输入电话所在组', trigger: 'blur' }
        ],
        sip_id_list: [
          { required: true, message: '请输入电话所在list', trigger: 'blur' }
        ],
        sip_svrip: [
          { required: true, message: '请输入SIP服务器地址', trigger: 'blur' }
        ],
        orgid: [
          { required: true, message: '请选择所属组织', trigger: 'change' }
        ],
        sip_type: [
          { required: true, message: '请选择电话类型', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.getData()
  },
  mounted () {
  },
  methods: {
    getData () {
      // console.log(this.sipAddEditRow)
      this.orgOptions = this.sipAddEditRow.orgTree
      if (this.sipAddEditRow.isAdd) {
        this.sipObj.id = 0
      } else {
        this.sipObj.id = this.sipAddEditRow.row.id
        this.sipObj.orgid = this.sipAddEditRow.row.orgid
        this.sipObj.username = this.sipAddEditRow.row.username
        this.sipObj.password = this.sipAddEditRow.row.password
        this.sipObj.sip_username = this.sipAddEditRow.row.sip_username
        this.sipObj.sip_password = this.sipAddEditRow.row.sip_password
        this.sipObj.sip_orgid = this.sipAddEditRow.row.sip_orgid
        this.sipObj.sip_id_list = this.sipAddEditRow.row.sip_id_list
        this.sipObj.sip_svrip = this.sipAddEditRow.row.sip_svrip
        this.sipObj.sip_type = this.sipAddEditRow.row.sip_type
      }
    },
    addEditSip (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            id: this.sipObj.id,
            orgid: this.sipObj.orgid,
            username: this.sipObj.username,
            password: this.sipObj.password,
            sip_username: this.sipObj.sip_username,
            sip_password: this.sipObj.sip_password,
            sip_orgid: this.sipObj.sip_orgid,
            sip_id_list: this.sipObj.sip_id_list,
            sip_svrip: this.sipObj.sip_svrip,
            sip_type: parseInt(this.sipObj.sip_type)
          }
          if (this.sipAddEditRow.isAdd) {
            addsip(data).then(res => {
              this.$notify({
                title: '成功',
                message: '成功添加sip电话',
                type: 'success',
                duration: 2000
              })
              this.golobleObject.updateTableSIP()
              this.$emit('change', false)
            }).catch(() => {
              this.$notify.error({
                title: '失败',
                message: '添加sip电话失败'
              })
            })
          } else {
            updatesip(data).then(res => {
              this.$notify({
                title: '成功',
                message: '成功修改sip电话',
                type: 'success',
                duration: 2000
              })
              this.golobleObject.updateTableSIP()
              this.$emit('change', false)
            }).catch(() => {
              this.$notify.error({
                title: '失败',
                message: '修改sip电话失败'
              })
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    closeAddEdit () {
      this.$emit('change', false)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/sipAddEdit.vue